import { useEffect, useState } from 'react';

interface DateFormatSelectorProps {
  onCancel: () => void;
  onConfirm: (val: string) => void;
  dateOptions: string[] | null;
}

function DateFormatSelector({
  dateOptions,
  onConfirm,
  onCancel,
}: DateFormatSelectorProps) {
  const [selected, setSelected] = useState<string>();

  useEffect(() => {
    if (!dateOptions?.length || selected) return;
    setSelected(dateOptions[0]);
  }, [dateOptions, selected]);

  const onSelect = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = evt.currentTarget;
    setSelected(value);
  };

  // JSX
  return dateOptions?.length ? (
    <section className="text-black fixed top-0 left-0 z-[500] w-full h-screen bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white w-[28rem] h-fit flex flex-col gap-3 justify-between shadow-sm rounded px-6 py-6">
        <div>
          <div className="text-error text-xl font-semibold">
            Multiple Date Formats Detected
          </div>
          <div>Please select the appropriate date format below:</div>
        </div>
        <div className="flex flex-col text-sm gap-2">
          {dateOptions.map((dateFormat) => (
            <label
              className="inline-flex items-center cursor-pointer"
              key={dateFormat}
            >
              <input
                type="radio"
                name="optionGroup"
                value={dateFormat}
                className="form-radio text-blue-600 peer"
                onChange={onSelect}
                checked={selected === dateFormat}
                id={dateFormat}
              />
              <span className="ml-2">{dateFormat}</span>
            </label>
          ))}
        </div>
        <div className="flex justify-end items-center gap-4 font-medium mt-4">
          <div
            onClick={() => {
              if (selected === undefined) {
                throw new Error('Date format selection required.');
              }
              onCancel();
            }}
            className="border border-error text-error capitalize rounded flex justify-center items-center py-1 px-4 cursor-pointer select-none"
          >
            cancel
          </div>
          <div
            onClick={() => {
              if (selected === undefined) {
                throw new Error('Date format selection required.');
              }
              onConfirm(selected);
            }}
            className="bg-success capitalize text-white rounded flex justify-center items-center py-1 px-4 cursor-pointer select-none"
          >
            confirm
          </div>
        </div>
      </div>
    </section>
  ) : null;
}
export default DateFormatSelector;
